import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../App";
import { ArrowLeft, BookOpen, Heart } from "lucide-react";

export default function AssembledStory() {
  const navigate = useNavigate();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get("/easter-eggs/assembled-story").then(res => {
      setStory(res.data);
      setLoading(false);
    }).catch(err => {
      setError(err.response?.data?.detail || "You need to find all 21 fragments first.");
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#F7931A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center gap-4 px-4">
        <BookOpen className="text-zinc-600" size={48} />
        <p className="text-zinc-400 text-center">{error}</p>
        <button onClick={() => navigate("/easter-eggs")} className="text-[#F7931A] text-sm hover:underline">
          Back to Easter Eggs
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="assembled-story-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/easter-eggs")} className="text-zinc-400 hover:text-white">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-lg font-bold text-white">THE BITCOIN BRAIN STORY</h1>
          <Heart className="text-[#F7931A]" size={20} />
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <h2 className="font-heading text-3xl font-bold text-white">{story.title}</h2>
          <p className="text-[#F7931A] text-sm mt-2">{story.subtitle}</p>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
          className="card-dark p-8 mb-8 border-[#F7931A]/20"
        >
          <p className="text-zinc-300 text-sm leading-loose font-serif italic">{story.intro}</p>
        </motion.div>

        <div className="space-y-8">
          {story.fragments?.map((frag, i) => (
            <motion.div key={frag.section}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 + i * 0.1 }}
              className="border-l-2 border-[#F7931A]/30 pl-6"
            >
              <p className="text-[#F7931A] text-xs font-mono mb-2">{frag.title}</p>
              <p className="text-zinc-300 text-sm leading-relaxed font-serif">{frag.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 3 }}
          className="text-center mt-16 pt-8 border-t border-white/10"
        >
          <p className="text-[#F7931A] font-heading text-xl font-bold">In Bitcoin We Trust.</p>
          <p className="text-zinc-500 text-xs mt-4">— Bryce Fields, California, 2026</p>
        </motion.div>
      </main>
    </div>
  );
}
